import React, { useState, useEffect, useContext } from "react";
import { useLocation, useHistory, useParams } from "react-router-dom";
import {
  AppBar, Badge, Toolbar, IconButton, Avatar, Divider, Box
} from '@mui/material';
import { NotificationsNoneOutlined, Menu as MenuIcon, MenuOpen as MenuOpenIcon } from '@mui/icons-material';
import { useTranslation } from "react-i18next";
/* import { useAuth0 } from "@auth0/auth0-react"; */
import { Link } from "react-router-dom/cjs/react-router-dom.min";
import "./navbar.css";
import { useMediaQuery } from "react-responsive";
import 'react-toastify/dist/ReactToastify.css';
import PassGoLogo from "../../src/assets/PassGoLogo.png";
import { useNotificacionesContext } from "./context/NotificationContext";
import { api } from '../services/api';
import { PaginatorContext } from "../providers/Paginator";
import { DrawerContext } from "./navbar/DrawerContext";

import MenuDrawer from './navbar/MenuDrawer';
import NotificationsMenu from './navbar/NotificationsMenu';
import ProfileMenu from './navbar/ProfileMenu';
import { is } from "date-fns/locale";
import { useAuth } from "./context/AuthContext";

const NavBar = () => {
  const location = useLocation();
  const isMobile = useMediaQuery({ query: `(max-width: 770px)` });
  const [t] = useTranslation("global");
  const { notificaciones } = useNotificacionesContext();
  const [isEventoRoute, setIsEventoRoute] = useState(false);
  const [isImpresionRoute, setIsImpresionRoute] = useState(false);
  const [isProfileRoute, setIsProfileRoute] = useState(false);
  const isPreviewRoute = location.pathname.includes('/preview/');
  const isUbicacionesRoute = location.pathname.includes('/ubicaciones');
  const { drawerOpen, setDrawerOpen, isDrawerTransitioning, drawerLoading } = useContext(DrawerContext);
  const [userClosedDrawer, setUserClosedDrawer] = useState(false);
  const history = useHistory();
  const handleLogin = () => {
    const returnTo = location.pathname; // o window.location.pathname
    history.push(`/login`);
  };
  useEffect(() => {
    const isEventRoute = location.pathname.includes('/eventos/');
    const isImpresionRuta = location.pathname.includes('/impresion');
    const isPerfilRuta = location.pathname.includes('/profile');

    setIsEventoRoute(isEventRoute);
    setIsImpresionRoute(isImpresionRuta);
    setIsProfileRoute(isPerfilRuta);
    const drawerClosedManually = window.localStorage.getItem("drawerClosedManually") === "true";
    setUserClosedDrawer(drawerClosedManually);

    if ((isEventRoute || isPerfilRuta) && !isDrawerTransitioning && !drawerClosedManually && !isPreviewRoute && !isImpresionRuta && !isMobile && !isUbicacionesRoute) {
      setDrawerOpen(true);
    }

    if (isUbicacionesRoute) {
      setDrawerOpen(false);
      document.body.classList.remove('drawer-open');
      return;
    }

    if (!isEventRoute && !isPerfilRuta) {
      setUserClosedDrawer(false);
      window.localStorage.removeItem("drawerClosedManually");
    }

    if (drawerOpen && !isMobile && !drawerLoading && !isPreviewRoute && !isUbicacionesRoute /* && !isImpresionRuta */) {
      document.body.classList.add('drawer-open');
    } else {
      document.body.classList.remove('drawer-open');
    }

    return () => document.body.classList.remove("drawer-open");
  }, [
    location.pathname,
    userClosedDrawer,
    drawerOpen,
    isMobile,
    drawerLoading,
    isPreviewRoute,
    isImpresionRoute,
    isDrawerTransitioning,
    isUbicacionesRoute
  ]);

  // saco el id del evento
  const eventoIdMatch = /\/eventos\/([^/]+)/.exec(location.pathname);
  const eventoId = eventoIdMatch ? eventoIdMatch[1] : undefined;

  const paginatorContext = useContext(PaginatorContext);
  const setIsToggled = paginatorContext?.setIsToggled;

  const [eventoActual, setEventoActual] = useState(null);
  const [userRole, setUserRole] = useState(null);
  const [qrOption, setQROption] = useState('');

  const [expandedMenus, setExpandedMenus] = useState({});
  const toggleExpandMenu = (menuName) => {
    setExpandedMenus(prev => ({
      ...prev,
      [menuName]: !prev[menuName]
    }));
  };

  const {
    user,
    isAuthenticated,
    loginWithRedirect,
    logout,
    logoutWithRedirect
  } = useAuth();

  const getUserAvatar = (usuario, size = 45) => {
    if (!usuario) return null;

    let initials = "";
    if (usuario.nombre || usuario.apellido) {
      initials =
        (usuario.nombre?.charAt(0) || "") +
        (usuario.apellido?.charAt(0) || "");
    } else if (usuario.usuario) {
      initials = usuario.usuario.charAt(0).toUpperCase();
    } else if (usuario.email) {
      initials = usuario.email.charAt(0).toUpperCase();
    } else {
      initials = "U";
    }

    const avatarStyle = {
      width: size,
      height: size,
      borderRadius: "50%",
      backgroundColor: "#3659E3",
      color: "white",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      fontSize: size / 2,
      fontWeight: "bold",
      userSelect: "none",
    };

    return <div style={avatarStyle}>{initials}</div>;
  };

  const [anchorElNotifications, setAnchorElNotifications] = useState(null);
  const [openNotifications, setOpenNotifications] = useState(false);
  const [anchorElProfile, setAnchorElProfiles] = useState(null);
  const [openProfile, setOpenProfile] = useState(false);

  // cargar los datos del evento
  useEffect(() => {
    const fetchEventoData = async () => {
      if (isEventoRoute && eventoId) {
        try {
          const response = await api.eventos.get(eventoId);
          if (response.status === "success") {
            setEventoActual(response.data.evento);
          }
        } catch (error) {
          console.error("Error al obtener datos del evento:", error);
        }
      } else {
        setEventoActual(null);
      }
    };

    fetchEventoData();
  }, [eventoId, isEventoRoute]);

  // obtener el rol del usuario en el evento
  useEffect(() => {
    const fetchRole = async () => {
      if (isEventoRoute && eventoId) {
        try {
          const response = await api.participaciones.getParticipaciones();
          if (response.status === "success") {
            const rol = response.data.participaciones.find(
              (p) => p.idevento == eventoId
            )?.idrol;

            setUserRole(rol);
          } else {
            setUserRole(3);
          }

          if (setIsToggled) {
            setIsToggled(false);
          }
        } catch (error) {
          console.error("Error al obtener el rol:", error);
          setUserRole(3);
        }
      }
    };

    fetchRole();
  }, [eventoId, isEventoRoute, setIsToggled]);

  const handleNotificationsClick = (event) => {
    setAnchorElNotifications(event.currentTarget);
    setOpenNotifications(!openNotifications);
    if (openProfile) setOpenProfile(false);
  };

  const handleProfileClick = (event) => {
    setAnchorElProfiles(event.currentTarget);
    setOpenProfile(!openProfile);
    if (openNotifications) setOpenNotifications(false);
  };

  const handleClose = () => {
    setOpenNotifications(false);
    setOpenProfile(false);
  };

  /* const logoutWithRedirect = () => {
    localStorage.removeItem("token");
    logout({
      logoutParams: {
        returnTo: window.location.origin,
      },
    });
  }; */

  const handleToggleDrawer = () => {
    if (drawerOpen && (isEventoRoute || isProfileRoute)) {
      setUserClosedDrawer(true);
      window.localStorage.setItem("drawerClosedManually", "true");
    }
    setDrawerOpen(!drawerOpen);
  };

  const closeMenus = () => {
    setDrawerOpen(false);
    setOpenNotifications(false);
    setOpenProfile(false);

    if (isMobile && (isEventoRoute || isProfileRoute)) {
      setUserClosedDrawer(true);
      window.localStorage.setItem("drawerClosedManually", "true");
    }
  };

  const unreadCount = notificaciones.filter(
    (notificacion) => notificacion.atendido == null
  ).length;

  return (
    <>
      <AppBar className="passgo-navbar py-1" position="fixed" sx={{
        boxShadow: 'none',
        backgroundColor: '#0b0060',
        width: '100%',
        zIndex: 1201,
        height: '72px',
        top: 0,
        left: 0,
      }}>
        <Toolbar className="d-flex justify-content-between">
          {/*LADO IZQ MENU + LOGO*/}
          <div className="d-flex align-items-center">
            {!isPreviewRoute && !isUbicacionesRoute && (
              <IconButton
                edge="start"
                color="inherit"
                aria-label={drawerOpen ? "close menu" : "open menu"}
                onClick={handleToggleDrawer}
              >
                {drawerOpen ? <MenuOpenIcon /> : <MenuIcon />}
              </IconButton>
            )}

            <Link to="/" className={isMobile ? "mr-2" : "mr-5"}>
              {isMobile ? (
                <svg width="39" height="32" viewBox="0 0 34 41" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M12.8809 0.202271C17.4303 0.273889 21.7993 0.0948437 26.0238 0.452934C31.2593 0.918451 34.6894 4.6784 33.7145 8.68901C32.7758 12.5564 31.5481 16.3879 30.2844 20.2553C29.8511 21.5444 28.9845 22.7978 28.0819 23.9795C25.7349 26.9516 22.0881 28.2407 17.7914 28.563C16.4554 28.6704 15.0834 28.7063 13.5669 28.7779C12.9892 30.7116 12.4115 32.5736 11.8338 34.4715C11.5449 35.4025 11.2561 36.3694 10.9672 37.3004C10.4617 39.0193 8.43971 40.3442 6.12887 40.559L0.423981 40.9887C4.6846 27.0948 8.80078 13.4874 12.8809 0.202271ZM15.4083 22.4039C19.4523 22.6187 21.1493 21.7235 22.1964 18.823C22.5936 17.7129 22.8825 16.567 23.2435 15.4569C23.8574 13.38 24.5073 11.3389 25.0489 9.26195C25.5544 7.36408 24.5795 6.43304 22.0881 6.39723C21.4743 6.39723 20.8966 6.39723 20.2106 6.39723C18.5858 11.7328 16.997 17.0325 15.4083 22.4039Z" fill="#fff" />
                </svg>
              ) : (
                <img src={PassGoLogo} width="75px" alt="PassGo logo" />
              )}
            </Link>

            {isEventoRoute && eventoActual && /* !isMobile && */ (
              <div className="d-flex align-items-center event-title-header">
                <span style={{ fontSize: '16px', fontWeight: '500' }}>
                  {isMobile
                    ? eventoActual.evento.length > 16
                      ? `${eventoActual.evento.slice(0, 16)}...`
                      : eventoActual.evento
                    : eventoActual.evento}</span>
              </div>
            )}
          </div>

          {/* LADO DCHO - NOTIF DESKTOP + AVATAR*/}
          {isAuthenticated ? (
            <div className="d-flex align-items-center gap-3">
              {!isMobile && (
                <IconButton
                  id="notificationsDropdown"
                  onClick={handleNotificationsClick}
                >
                  <Badge
                    badgeContent={unreadCount > 9 ? "9+" : unreadCount}
                    color="error"
                    overlap="circular"
                  >
                    <NotificationsNoneOutlined style={{ color: "white", fontSize: "26px" }} />
                  </Badge>
                </IconButton>
              )}

              <div onClick={handleProfileClick} style={{ cursor: "pointer" }}>
                {getUserAvatar(user, isMobile ? 40 : 45)}
              </div>

              <NotificationsMenu
                anchorEl={anchorElNotifications}
                open={openNotifications}
                handleClose={handleClose}
                notificaciones={notificaciones}
                closeMenus={closeMenus}
              />

              <ProfileMenu
                anchorEl={anchorElProfile}
                open={openProfile}
                handleClose={handleClose}
                logoutWithRedirect={logoutWithRedirect}
                closeMenus={closeMenus}
              />
            </div>
          ) : (
            <div className="d-flex flex-row">
              <Link to="/login" style={{ textDecoration: "none" }}>
                <button
                  style={{
                    backgroundColor: "#ffd500",
                    color: "black",
                    border: "none",
                    borderRadius: "30px",
                    padding: isMobile ? "8px 16px" : "12px 24px",
                    fontSize: isMobile ? "14px" : "16px",
                    fontWeight: "500",
                    cursor: "pointer",
                  }}
                  type="button"
                >
                  Mi Cuenta
                </button>
              </Link>
            </div>
          )}
        </Toolbar>
      </AppBar>

      {!drawerLoading && !isPreviewRoute && !isImpresionRoute && (
        <MenuDrawer
          drawerOpen={drawerOpen}
          toggleDrawer={handleToggleDrawer}
          isEventoRoute={isEventoRoute}
          isProfileRoute={isProfileRoute}
          user={user}
          eventoActual={eventoActual}
          closeMenus={closeMenus}
          eventoId={eventoId}
          userRole={userRole}
          setQROption={setQROption}
          expandedMenus={expandedMenus}
          toggleExpandMenu={toggleExpandMenu}
          isAuthenticated={isAuthenticated}
          unreadCount={unreadCount}
          loginWithRedirect={loginWithRedirect}
          logoutWithRedirect={logoutWithRedirect}
          isMobile={isMobile}
          hideCloseButton={true}
        />
      )}
    </>
  );
};

export default NavBar;